// This file is auto-generated by @hey-api/openapi-ts

import type {
  AuthenticationPermissionGroupAssignmentsCreateResponse,
  AuthenticationPermissionGroupAssignmentsRetrieveResponse,
  AuthenticationPermissionGroupAssignmentsSearchCreateResponse,
  AuthenticationPermissionGroupAssignmentsUpdateResponse,
  AuthenticationPermissionGroupsCreateResponse,
  AuthenticationPermissionGroupsRetrieveResponse,
  AuthenticationPermissionGroupsSearchCreateResponse,
  AuthenticationPermissionGroupsUpdateResponse,
  AuthenticationRoleAssignmentsCreateResponse,
  AuthenticationRoleAssignmentsRetrieveResponse,
  AuthenticationRoleAssignmentsSearchCreateResponse,
  AuthenticationRolesCreateResponse,
  AuthenticationRolesPartialUpdateResponse,
  AuthenticationRolesRetrieveResponse,
  AuthenticationRolesSearchCreateResponse,
  AuthenticationRolesUpdateResponse,
  BackgroundTasksTasksRetrieveResponse,
  DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse,
  DirectoutreachPolicyAvailableListResponse,
  DirectoutreachPolicyAvailableRetrieveResponse,
  DirectoutreachPolicyCreateResponse,
  DirectoutreachVotersCreateCreateResponse,
  DirectoutreachVotersHoldingsRetrieveResponse,
  DirectoutreachVotersSelectedPolicyCreateResponse,
  DirectoutreachVotersSelectedPolicyRetrieveResponse,
  DirectvotingBallotsCastVoteCreateResponse,
  DirectvotingBallotsProposalsRetrieveResponse,
  DirectvotingBallotsSearchCreateResponse,
  DirectvotingBallotStampsRetrieveResponse,
  DirectvotingBallotStampsSearchCreateResponse,
  DirectvotingBallotWorkflowItemsCreateResponse,
  DirectvotingBallotWorkflowItemsPartialUpdateResponse,
  DirectvotingBallotWorkflowItemsRetrieveResponse,
  DirectvotingBallotWorkflowItemsSearchCreateResponse,
  DirectvotingBeaconRuleOutputsCreateResponse,
  DirectvotingBeaconRuleOutputsRetrieveResponse,
  DirectvotingBeaconRuleOutputsSearchCreateResponse,
  DirectvotingBeaconVotingPoliciesCreateResponse,
  DirectvotingBeaconVotingPoliciesRetrieveResponse,
  DirectvotingBeaconVotingPoliciesSearchCreateResponse,
  DirectvotingCustodyAccountGroupMembershipsCreateResponse,
  DirectvotingCustodyAccountGroupMembershipsSearchCreateResponse,
  DirectvotingCustodyAccountGroupsCreateResponse,
  DirectvotingCustodyAccountGroupsPartialUpdateResponse,
  DirectvotingCustodyAccountGroupsRetrieveResponse,
  DirectvotingCustodyAccountGroupsSearchCreateResponse,
  DirectvotingCustodyAccountGroupsUpdateResponse,
  DirectvotingCustodyAccountTenantLinksLinkCreateResponse,
  DirectvotingCustodyAccountTenantLinksListResponse,
  DirectvotingCustodyAccountVotingPolicySelectionsCreateResponse,
  DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponse,
  DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponse,
  DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponse,
  DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponse,
  DirectvotingMeetingsAssignmentSearchCreateResponse,
  DirectvotingMeetingsSearchCreateResponse,
  DirectvotingRulesEngineRulesCreateResponse,
  DirectvotingRulesEngineRulesListsCreateResponse,
  DirectvotingRulesEngineRulesListsPartialUpdateResponse,
  DirectvotingRulesEngineRulesListsRetrieveResponse,
  DirectvotingRulesEngineRulesListsSearchCreateResponse,
  DirectvotingRulesEngineRulesPartialUpdateResponse,
  DirectvotingRulesEngineRulesRetrieveResponse,
  DirectvotingRulesEngineRulesSearchCreateResponse,
  DirectvotingTasksSearchCreateResponse,
  DirectvotingVotingPartiesCreateResponse,
  DirectvotingVotingPartiesPartialUpdateResponse,
  DirectvotingVotingPartiesRetrieveResponse,
  DirectvotingVotingPartiesSearchCreateResponse,
  DirectvotingWatchlistItemsBatchCreateResponse,
  DirectvotingWatchlistItemsCreateResponse,
  DirectvotingWatchlistItemsRetrieveResponse,
  DirectvotingWatchlistItemsSearchCreateResponse,
  DirectvotingWatchlistsCreateResponse,
  DirectvotingWatchlistsPartialUpdateResponse,
  DirectvotingWatchlistsRetrieveResponse,
  DirectvotingWatchlistsSearchCreateResponse,
  FundManagerFundManagersCreateResponse,
  FundManagerFundManagersPoliciesCreateResponse,
  FundManagerFundManagersPoliciesRetrieveResponse,
  FundManagerFundManagersRetrieveResponse,
  FundManagerFundManagersSearchCreateResponse,
  FundManagerFundManagersUpdateResponse,
  FundManagerFundsCreateResponse,
  FundManagerFundsQuantificationSnapshotsCreateResponse,
  FundManagerFundsRetrieveResponse,
  FundManagerFundsSearchCreateResponse,
  FundManagerFundsUpdateResponse,
  FundManagerFundVariantsCreateResponse,
  FundManagerFundVariantsRetrieveResponse,
  FundManagerFundVariantsSearchCreateResponse,
  FundManagerFundVariantsUpdateResponse,
  FundManagerProvidersCreateResponse,
  FundManagerProvidersListResponse,
  FundManagerProvidersRetrieveResponse,
  FundManagerProvidersUpdateResponse,
  FundManagerPublicSecurityIdsCreateResponse,
  FundManagerPublicSecurityIdsSearchCreateResponse,
  FundManagerQuantificationSnapshotsSearchCreateResponse,
  InstitutionalMeetingsearchListResponse,
  IssuerFiscalYearsSearchCreateResponse,
  IssuerInstrumentsOutstandingSharesRetrieveResponse,
  IssuerInstrumentsRetrieveResponse,
  IssuerInstrumentsSearchCreateResponse,
  IssuerInstrumentsTotalShareholderReturnRetrieveResponse,
  IssuerIssuersMarketCapitalisationRetrieveResponse,
  IssuerIssuersRetrieveResponse,
  IssuerIssuersSearchCreateResponse,
  IssuerMarketCapitalisationsSearchCreateResponse,
  IssuerOutstandingSharesSearchCreateResponse,
  IssuerTotalShareholderReturnsSearchCreateResponse,
  ProxyIntermediaryBallotsFetchByVersionIdsCreateResponse,
  ProxyIntermediaryBallotsProxymityStaleProposalSetListResponse,
  ProxyIntermediaryBallotsSearchCreateResponse,
  ProxyIntermediaryBallotsUpsertCreateResponse,
  ProxyIntermediaryBallotsVersionsListResponse,
  ProxyIntermediaryCustodyAccountsCreateResponse,
  ProxyIntermediaryCustodyAccountsPartialUpdateResponse,
  ProxyIntermediaryCustodyAccountsRetrieveResponse,
  ProxyIntermediaryCustodyAccountsSearchCreateResponse,
  ProxyIntermediaryCustodyAccountsUpdateResponse,
  ProxyIntermediaryProposalsCreateCreateResponse,
  ProxyIntermediaryProposalsProposalCategorySearchCreateResponse,
  ProxyIntermediaryProposalsSearchCreateResponse,
  ProxyIntermediaryProxyedgeVotesCreateCreateResponse,
  ProxyIntermediaryProxyedgeVotesFetchLatestCreateResponse,
  ProxyIntermediaryProxyIntermediariesSearchCreateResponse,
  ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponse,
  ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponse,
  ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponse,
  ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponse,
  ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponse,
  ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponse,
  ProxyIntermediaryProxymityVotesCreateCreateResponse,
  ProxyIntermediaryProxymityVotesFetchLatestCreateResponse,
  ProxyIntermediaryVoteStatusesUpsertCreateResponse,
  ProxyvotingEntitlementsListResponse,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponse,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponse,
  ProxyvotingFundManagerSupportedPoliciesCreateResponse,
  ProxyvotingFundManagerSupportedPoliciesListResponse,
  ProxyvotingInvestorCompositionsDifferenceListResponse,
  ProxyvotingInvestorCompositionsRulesEngineRetrieveResponse,
  ProxyvotingInvestorCompositionsRulesEngineUpdateResponse,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponse,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponse,
  ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponse,
  ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponse,
  ProxyvotingMeetingBallotsListResponse,
  ProxyvotingMeetingBallotSourcesListResponse,
  ProxyvotingPiballotsFilterListResponse,
  ProxyvotingPimeetingsFilterListResponse,
  ProxyvotingRulesEngineDefinitionsCreateResponse,
  ProxyvotingRulesEngineDefinitionsListResponse,
  ProxyvotingRulesEngineDefinitionsRetrieveResponse,
  ProxyvotingRulesEngineDefinitionsRulesCreateResponse,
  ProxyvotingRulesEngineDefinitionsRulesListResponse,
  ProxyvotingRulesEngineDefinitionsRulesUpdateResponse,
  ProxyvotingSviProposalOverwriteCreateResponse,
  ProxyvotingSviSubmitVoteCreateResponse,
  TenancyTenantsCreateResponse,
  TenancyTenantsRetrieveResponse,
  TenancyTenantsSearchCreateResponse,
  TenancyTenantsUpdateResponse,
  TenancyUsersCreateResponse,
  TenancyUsersRetrieveResponse,
  TenancyUsersSearchCreateResponse,
  TenancyUsersUpdateResponse,
  TransparencyAuditEventsSearchCreateResponse,
  TransparencyExternalMeetingIdsCreateResponse,
  TransparencyGeneralMeetingsCreateResponse,
  TransparencyGeneralMeetingsPartialUpdateResponse,
  TransparencyGeneralMeetingsRetrieveResponse,
  TransparencyGeneralMeetingsSearchCreateResponse,
  TransparencyOrganizationsCreateResponse,
  TransparencyOrganizationsGeneralMeetingsProposalsCreateResponse,
  TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponse,
  TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponse,
  TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponse,
  TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponse,
  TransparencyOrganizationsGetByIdentifierCreateResponse,
  TransparencyOrganizationsLogoCreateResponse,
  TransparencyOrganizationsPartialUpdateResponse,
  TransparencyOrganizationsRetrieveResponse,
  TransparencyOrganizationsSearchCreateResponse,
  TransparencyOrganizationsUpdateResponse,
  TransparencyProposalsFetchCreateResponse,
  TransparencyPublicSecurityIdsSearchCreateResponse,
  VotingOperationsPiballotsFilterListResponse,
  VotingOperationsPimeetingsFilterListResponse,
  VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponse,
  VotingPolicyProposalSetRecommendationCoverageSearchCreateResponse,
  VotingPolicyProviderVotingRecommendationsCreateResponse,
  VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponse,
  VotingPolicyProviderVotingRecommendationsMatchCreateResponse,
  VotingPolicyProviderVotingRecommendationsSearchCreateResponse,
  VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponse,
  VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponse,
  VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponse,
  VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponse,
  VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponse,
  VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponse,
  VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponse,
  VotingPolicyVotingPoliciesCreateResponse,
  VotingPolicyVotingPoliciesDocumentsCreateResponse,
  VotingPolicyVotingPoliciesDocumentsListResponse,
  VotingPolicyVotingPoliciesDocumentsPartialUpdateResponse,
  VotingPolicyVotingPoliciesDocumentsRetrieveResponse,
  VotingPolicyVotingPoliciesPartialUpdateResponse,
  VotingPolicyVotingPoliciesRetrieveResponse,
  VotingPolicyVotingPoliciesSearchCreateResponse,
  VotingPolicyVotingPoliciesVotingRecommendationsCreateResponse,
  VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponse,
  VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponse,
  VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponse,
  VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponse,
  VotingPolicyVotingRecommendationConfidenceScoresUpdateResponse,
} from './types.gen'

const permissionGroupAssignmentSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const authenticationPermissionGroupAssignmentsCreateResponseTransformer = async (
  data: any
): Promise<AuthenticationPermissionGroupAssignmentsCreateResponse> => {
  data = permissionGroupAssignmentSchemaResponseTransformer(data)
  return data
}

export const authenticationPermissionGroupAssignmentsRetrieveResponseTransformer = async (
  data: any
): Promise<AuthenticationPermissionGroupAssignmentsRetrieveResponse> => {
  data = permissionGroupAssignmentSchemaResponseTransformer(data)
  return data
}

export const authenticationPermissionGroupAssignmentsUpdateResponseTransformer = async (
  data: any
): Promise<AuthenticationPermissionGroupAssignmentsUpdateResponse> => {
  data = permissionGroupAssignmentSchemaResponseTransformer(data)
  return data
}

const paginatedPermissionGroupAssignmentListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => permissionGroupAssignmentSchemaResponseTransformer(item))
  return data
}

export const authenticationPermissionGroupAssignmentsSearchCreateResponseTransformer = async (
  data: any
): Promise<AuthenticationPermissionGroupAssignmentsSearchCreateResponse> => {
  data = paginatedPermissionGroupAssignmentListSchemaResponseTransformer(data)
  return data
}

const permissionGroupSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const authenticationPermissionGroupsCreateResponseTransformer = async (
  data: any
): Promise<AuthenticationPermissionGroupsCreateResponse> => {
  data = permissionGroupSchemaResponseTransformer(data)
  return data
}

export const authenticationPermissionGroupsRetrieveResponseTransformer = async (
  data: any
): Promise<AuthenticationPermissionGroupsRetrieveResponse> => {
  data = permissionGroupSchemaResponseTransformer(data)
  return data
}

export const authenticationPermissionGroupsUpdateResponseTransformer = async (
  data: any
): Promise<AuthenticationPermissionGroupsUpdateResponse> => {
  data = permissionGroupSchemaResponseTransformer(data)
  return data
}

const paginatedPermissionGroupListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => permissionGroupSchemaResponseTransformer(item))
  return data
}

export const authenticationPermissionGroupsSearchCreateResponseTransformer = async (
  data: any
): Promise<AuthenticationPermissionGroupsSearchCreateResponse> => {
  data = paginatedPermissionGroupListSchemaResponseTransformer(data)
  return data
}

const roleAssignmentSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const authenticationRoleAssignmentsCreateResponseTransformer = async (
  data: any
): Promise<AuthenticationRoleAssignmentsCreateResponse> => {
  data = roleAssignmentSchemaResponseTransformer(data)
  return data
}

export const authenticationRoleAssignmentsRetrieveResponseTransformer = async (
  data: any
): Promise<AuthenticationRoleAssignmentsRetrieveResponse> => {
  data = roleAssignmentSchemaResponseTransformer(data)
  return data
}

const paginatedRoleAssignmentListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => roleAssignmentSchemaResponseTransformer(item))
  return data
}

export const authenticationRoleAssignmentsSearchCreateResponseTransformer = async (
  data: any
): Promise<AuthenticationRoleAssignmentsSearchCreateResponse> => {
  data = paginatedRoleAssignmentListSchemaResponseTransformer(data)
  return data
}

const roleSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const authenticationRolesCreateResponseTransformer = async (
  data: any
): Promise<AuthenticationRolesCreateResponse> => {
  data = roleSchemaResponseTransformer(data)
  return data
}

export const authenticationRolesRetrieveResponseTransformer = async (
  data: any
): Promise<AuthenticationRolesRetrieveResponse> => {
  data = roleSchemaResponseTransformer(data)
  return data
}

export const authenticationRolesPartialUpdateResponseTransformer = async (
  data: any
): Promise<AuthenticationRolesPartialUpdateResponse> => {
  data = roleSchemaResponseTransformer(data)
  return data
}

export const authenticationRolesUpdateResponseTransformer = async (
  data: any
): Promise<AuthenticationRolesUpdateResponse> => {
  data = roleSchemaResponseTransformer(data)
  return data
}

const paginatedRoleListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => roleSchemaResponseTransformer(item))
  return data
}

export const authenticationRolesSearchCreateResponseTransformer = async (
  data: any
): Promise<AuthenticationRolesSearchCreateResponse> => {
  data = paginatedRoleListSchemaResponseTransformer(data)
  return data
}

const taskStatusSchemaResponseTransformer = (data: any) => {
  data.scheduled_at = new Date(data.scheduled_at)
  if (data.started_at) {
    data.started_at = new Date(data.started_at)
  }
  return data
}

export const backgroundTasksTasksRetrieveResponseTransformer = async (
  data: any
): Promise<BackgroundTasksTasksRetrieveResponse> => {
  data = taskStatusSchemaResponseTransformer(data)
  return data
}

const exportResultSchemaResponseTransformer = (data: any) => {
  data.exported_at = new Date(data.exported_at)
  return data
}

export const directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer = async (
  data: any
): Promise<DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse> => {
  data = exportResultSchemaResponseTransformer(data)
  return data
}

const policySchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const directoutreachPolicyCreateResponseTransformer = async (
  data: any
): Promise<DirectoutreachPolicyCreateResponse> => {
  data = policySchemaResponseTransformer(data)
  return data
}

const policyResponseSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const directoutreachPolicyAvailableListResponseTransformer = async (
  data: any
): Promise<DirectoutreachPolicyAvailableListResponse> => {
  data = data.map((item: any) => policyResponseSchemaResponseTransformer(item))
  return data
}

export const directoutreachPolicyAvailableRetrieveResponseTransformer = async (
  data: any
): Promise<DirectoutreachPolicyAvailableRetrieveResponse> => {
  data = policyResponseSchemaResponseTransformer(data)
  return data
}

const holdingSchemaResponseTransformer = (data: any) => {
  data.valid_time = new Date(data.valid_time)
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const holdingResponseSchemaResponseTransformer = (data: any) => {
  data.holdings = data.holdings.map((item: any) => holdingSchemaResponseTransformer(item))
  return data
}

export const directoutreachVotersHoldingsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectoutreachVotersHoldingsRetrieveResponse> => {
  data = holdingResponseSchemaResponseTransformer(data)
  return data
}

const selectedPolicySchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const selectedPolicyResponseSchemaResponseTransformer = (data: any) => {
  if (data.selectedPolicy) {
    data.selectedPolicy = selectedPolicySchemaResponseTransformer(data.selectedPolicy)
  }
  return data
}

export const directoutreachVotersSelectedPolicyRetrieveResponseTransformer = async (
  data: any
): Promise<DirectoutreachVotersSelectedPolicyRetrieveResponse> => {
  data = selectedPolicyResponseSchemaResponseTransformer(data)
  return data
}

export const directoutreachVotersSelectedPolicyCreateResponseTransformer = async (
  data: any
): Promise<DirectoutreachVotersSelectedPolicyCreateResponse> => {
  data = selectedPolicyResponseSchemaResponseTransformer(data)
  return data
}

const voterWithHoldingsResponseSchemaResponseTransformer = (data: any) => {
  data.holdings = data.holdings.map((item: any) => holdingSchemaResponseTransformer(item))
  return data
}

export const directoutreachVotersCreateCreateResponseTransformer = async (
  data: any
): Promise<DirectoutreachVotersCreateCreateResponse> => {
  data = voterWithHoldingsResponseSchemaResponseTransformer(data)
  return data
}

const directVotingBallotStampSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const directvotingBallotStampsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingBallotStampsRetrieveResponse> => {
  data = directVotingBallotStampSchemaResponseTransformer(data)
  return data
}

const paginatedDirectVotingBallotStampListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => directVotingBallotStampSchemaResponseTransformer(item))
  return data
}

export const directvotingBallotStampsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingBallotStampsSearchCreateResponse> => {
  data = paginatedDirectVotingBallotStampListSchemaResponseTransformer(data)
  return data
}

const directVotingBallotWorkflowItemSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const directvotingBallotWorkflowItemsCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingBallotWorkflowItemsCreateResponse> => {
  data = directVotingBallotWorkflowItemSchemaResponseTransformer(data)
  return data
}

export const directvotingBallotWorkflowItemsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingBallotWorkflowItemsRetrieveResponse> => {
  data = directVotingBallotWorkflowItemSchemaResponseTransformer(data)
  return data
}

export const directvotingBallotWorkflowItemsPartialUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingBallotWorkflowItemsPartialUpdateResponse> => {
  data = directVotingBallotWorkflowItemSchemaResponseTransformer(data)
  return data
}

const paginatedDirectVotingBallotWorkflowItemListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => directVotingBallotWorkflowItemSchemaResponseTransformer(item))
  return data
}

export const directvotingBallotWorkflowItemsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingBallotWorkflowItemsSearchCreateResponse> => {
  data = paginatedDirectVotingBallotWorkflowItemListSchemaResponseTransformer(data)
  return data
}

const directVoteInstructionSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const castVoteResponseSchemaResponseTransformer = (data: any) => {
  data.instructions = data.instructions.map((item: any) => directVoteInstructionSchemaResponseTransformer(item))
  return data
}

export const directvotingBallotsCastVoteCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingBallotsCastVoteCreateResponse> => {
  data = castVoteResponseSchemaResponseTransformer(data)
  return data
}

const ballotProposalVotingInstructionSchemaResponseTransformer = (data: any) => {
  data.update_time = new Date(data.update_time)
  return data
}

const ballotProposalSchemaResponseTransformer = (data: any) => {
  if (data.voting_instruction) {
    data.voting_instruction = ballotProposalVotingInstructionSchemaResponseTransformer(data.voting_instruction)
  }
  return data
}

const ballotProposalsResponseSchemaResponseTransformer = (data: any) => {
  data.proposals = data.proposals.map((item: any) => ballotProposalSchemaResponseTransformer(item))
  return data
}

export const directvotingBallotsProposalsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingBallotsProposalsRetrieveResponse> => {
  data = ballotProposalsResponseSchemaResponseTransformer(data)
  return data
}

const tenantBallotSchemaResponseTransformer = (data: any) => {
  data.available_shares = BigInt(data.available_shares.toString())
  data.vote_deadline = new Date(data.vote_deadline)
  return data
}

const paginatedTenantBallotListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => tenantBallotSchemaResponseTransformer(item))
  return data
}

export const directvotingBallotsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingBallotsSearchCreateResponse> => {
  data = paginatedTenantBallotListSchemaResponseTransformer(data)
  return data
}

const directVotingBeaconRuleOutputProposalSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const directVotingBeaconRuleOutputSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.proposals = data.proposals.map((item: any) =>
    directVotingBeaconRuleOutputProposalSchemaResponseTransformer(item)
  )
  return data
}

export const directvotingBeaconRuleOutputsCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingBeaconRuleOutputsCreateResponse> => {
  data = directVotingBeaconRuleOutputSchemaResponseTransformer(data)
  return data
}

export const directvotingBeaconRuleOutputsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingBeaconRuleOutputsRetrieveResponse> => {
  data = directVotingBeaconRuleOutputSchemaResponseTransformer(data)
  return data
}

const paginatedDirectVotingBeaconRuleOutputListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => directVotingBeaconRuleOutputSchemaResponseTransformer(item))
  return data
}

export const directvotingBeaconRuleOutputsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingBeaconRuleOutputsSearchCreateResponse> => {
  data = paginatedDirectVotingBeaconRuleOutputListSchemaResponseTransformer(data)
  return data
}

const directVotingBeaconVotingPolicySchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const directvotingBeaconVotingPoliciesCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingBeaconVotingPoliciesCreateResponse> => {
  data = directVotingBeaconVotingPolicySchemaResponseTransformer(data)
  return data
}

export const directvotingBeaconVotingPoliciesRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingBeaconVotingPoliciesRetrieveResponse> => {
  data = directVotingBeaconVotingPolicySchemaResponseTransformer(data)
  return data
}

const paginatedDirectVotingBeaconVotingPolicyListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => directVotingBeaconVotingPolicySchemaResponseTransformer(item))
  return data
}

export const directvotingBeaconVotingPoliciesSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingBeaconVotingPoliciesSearchCreateResponse> => {
  data = paginatedDirectVotingBeaconVotingPolicyListSchemaResponseTransformer(data)
  return data
}

const custodyAccountGroupMembershipSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  return data
}

export const directvotingCustodyAccountGroupMembershipsCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountGroupMembershipsCreateResponse> => {
  data = custodyAccountGroupMembershipSchemaResponseTransformer(data)
  return data
}

const paginatedCustodyAccountGroupMembershipListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => custodyAccountGroupMembershipSchemaResponseTransformer(item))
  return data
}

export const directvotingCustodyAccountGroupMembershipsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountGroupMembershipsSearchCreateResponse> => {
  data = paginatedCustodyAccountGroupMembershipListSchemaResponseTransformer(data)
  return data
}

const custodyAccountGroupSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const directvotingCustodyAccountGroupsCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountGroupsCreateResponse> => {
  data = custodyAccountGroupSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountGroupsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountGroupsRetrieveResponse> => {
  data = custodyAccountGroupSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountGroupsPartialUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountGroupsPartialUpdateResponse> => {
  data = custodyAccountGroupSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountGroupsUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountGroupsUpdateResponse> => {
  data = custodyAccountGroupSchemaResponseTransformer(data)
  return data
}

const paginatedCustodyAccountGroupListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => custodyAccountGroupSchemaResponseTransformer(item))
  return data
}

export const directvotingCustodyAccountGroupsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountGroupsSearchCreateResponse> => {
  data = paginatedCustodyAccountGroupListSchemaResponseTransformer(data)
  return data
}

const custodyAccountTenantLinkSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const paginatedCustodyAccountTenantLinkListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => custodyAccountTenantLinkSchemaResponseTransformer(item))
  return data
}

export const directvotingCustodyAccountTenantLinksListResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountTenantLinksListResponse> => {
  data = paginatedCustodyAccountTenantLinkListSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountTenantLinksLinkCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountTenantLinksLinkCreateResponse> => {
  data = custodyAccountTenantLinkSchemaResponseTransformer(data)
  return data
}

const custodyAccountVotingPolicySelectionSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const directvotingCustodyAccountVotingPolicySelectionsCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountVotingPolicySelectionsCreateResponse> => {
  data = custodyAccountVotingPolicySelectionSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountVotingPolicySelectionsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponse> => {
  data = custodyAccountVotingPolicySelectionSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponse> => {
  data = custodyAccountVotingPolicySelectionSchemaResponseTransformer(data)
  return data
}

export const directvotingCustodyAccountVotingPolicySelectionsUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponse> => {
  data = custodyAccountVotingPolicySelectionSchemaResponseTransformer(data)
  return data
}

const paginatedCustodyAccountVotingPolicySelectionListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => custodyAccountVotingPolicySelectionSchemaResponseTransformer(item))
  return data
}

export const directvotingCustodyAccountVotingPolicySelectionsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponse> => {
  data = paginatedCustodyAccountVotingPolicySelectionListSchemaResponseTransformer(data)
  return data
}

const meetingAssignmentSchemaResponseTransformer = (data: any) => {
  data.meeting_date = new Date(data.meeting_date)
  data.meeting_deadline = new Date(data.meeting_deadline)
  return data
}

const paginatedMeetingAssignmentListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => meetingAssignmentSchemaResponseTransformer(item))
  return data
}

export const directvotingMeetingsAssignmentSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingMeetingsAssignmentSearchCreateResponse> => {
  data = paginatedMeetingAssignmentListSchemaResponseTransformer(data)
  return data
}

const tenantMeetingSchemaResponseTransformer = (data: any) => {
  data.meeting_date = new Date(data.meeting_date)
  data.meeting_deadline = new Date(data.meeting_deadline)
  return data
}

const paginatedTenantMeetingListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => tenantMeetingSchemaResponseTransformer(item))
  return data
}

export const directvotingMeetingsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingMeetingsSearchCreateResponse> => {
  data = paginatedTenantMeetingListSchemaResponseTransformer(data)
  return data
}

const directVotingRulesEngineRuleSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const directvotingRulesEngineRulesCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingRulesEngineRulesCreateResponse> => {
  data = directVotingRulesEngineRuleSchemaResponseTransformer(data)
  return data
}

const directVotingRulesEngineRulesListSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const directvotingRulesEngineRulesListsCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingRulesEngineRulesListsCreateResponse> => {
  data = directVotingRulesEngineRulesListSchemaResponseTransformer(data)
  return data
}

export const directvotingRulesEngineRulesListsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingRulesEngineRulesListsRetrieveResponse> => {
  data = directVotingRulesEngineRulesListSchemaResponseTransformer(data)
  return data
}

export const directvotingRulesEngineRulesListsPartialUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingRulesEngineRulesListsPartialUpdateResponse> => {
  data = directVotingRulesEngineRulesListSchemaResponseTransformer(data)
  return data
}

const paginatedDirectVotingRulesEngineRulesListListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => directVotingRulesEngineRulesListSchemaResponseTransformer(item))
  return data
}

export const directvotingRulesEngineRulesListsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingRulesEngineRulesListsSearchCreateResponse> => {
  data = paginatedDirectVotingRulesEngineRulesListListSchemaResponseTransformer(data)
  return data
}

export const directvotingRulesEngineRulesRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingRulesEngineRulesRetrieveResponse> => {
  data = directVotingRulesEngineRuleSchemaResponseTransformer(data)
  return data
}

export const directvotingRulesEngineRulesPartialUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingRulesEngineRulesPartialUpdateResponse> => {
  data = directVotingRulesEngineRuleSchemaResponseTransformer(data)
  return data
}

const paginatedDirectVotingRulesEngineRuleListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => directVotingRulesEngineRuleSchemaResponseTransformer(item))
  return data
}

export const directvotingRulesEngineRulesSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingRulesEngineRulesSearchCreateResponse> => {
  data = paginatedDirectVotingRulesEngineRuleListSchemaResponseTransformer(data)
  return data
}

const taskSchemaResponseTransformer = (data: any) => {
  data.meeting_date = new Date(data.meeting_date)
  data.deadline = new Date(data.deadline)
  return data
}

const paginatedTaskListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => taskSchemaResponseTransformer(item))
  return data
}

export const directvotingTasksSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingTasksSearchCreateResponse> => {
  data = paginatedTaskListSchemaResponseTransformer(data)
  return data
}

const directVotingVotingPartySchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const directvotingVotingPartiesCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingVotingPartiesCreateResponse> => {
  data = directVotingVotingPartySchemaResponseTransformer(data)
  return data
}

export const directvotingVotingPartiesRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingVotingPartiesRetrieveResponse> => {
  data = directVotingVotingPartySchemaResponseTransformer(data)
  return data
}

export const directvotingVotingPartiesPartialUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingVotingPartiesPartialUpdateResponse> => {
  data = directVotingVotingPartySchemaResponseTransformer(data)
  return data
}

const paginatedDirectVotingVotingPartyListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => directVotingVotingPartySchemaResponseTransformer(item))
  return data
}

export const directvotingVotingPartiesSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingVotingPartiesSearchCreateResponse> => {
  data = paginatedDirectVotingVotingPartyListSchemaResponseTransformer(data)
  return data
}

const directVotingWatchlistItemSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const directvotingWatchlistItemsCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingWatchlistItemsCreateResponse> => {
  data = directVotingWatchlistItemSchemaResponseTransformer(data)
  return data
}

export const directvotingWatchlistItemsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingWatchlistItemsRetrieveResponse> => {
  data = directVotingWatchlistItemSchemaResponseTransformer(data)
  return data
}

const directVotingWatchlistItemBatchUpsertResponseSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) => directVotingWatchlistItemSchemaResponseTransformer(item))
  return data
}

export const directvotingWatchlistItemsBatchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingWatchlistItemsBatchCreateResponse> => {
  data = directVotingWatchlistItemBatchUpsertResponseSchemaResponseTransformer(data)
  return data
}

const paginatedDirectVotingWatchlistItemListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => directVotingWatchlistItemSchemaResponseTransformer(item))
  return data
}

export const directvotingWatchlistItemsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingWatchlistItemsSearchCreateResponse> => {
  data = paginatedDirectVotingWatchlistItemListSchemaResponseTransformer(data)
  return data
}

const directVotingWatchlistSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const directvotingWatchlistsCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingWatchlistsCreateResponse> => {
  data = directVotingWatchlistSchemaResponseTransformer(data)
  return data
}

export const directvotingWatchlistsRetrieveResponseTransformer = async (
  data: any
): Promise<DirectvotingWatchlistsRetrieveResponse> => {
  data = directVotingWatchlistSchemaResponseTransformer(data)
  return data
}

export const directvotingWatchlistsPartialUpdateResponseTransformer = async (
  data: any
): Promise<DirectvotingWatchlistsPartialUpdateResponse> => {
  data = directVotingWatchlistSchemaResponseTransformer(data)
  return data
}

const paginatedDirectVotingWatchlistListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => directVotingWatchlistSchemaResponseTransformer(item))
  return data
}

export const directvotingWatchlistsSearchCreateResponseTransformer = async (
  data: any
): Promise<DirectvotingWatchlistsSearchCreateResponse> => {
  data = paginatedDirectVotingWatchlistListSchemaResponseTransformer(data)
  return data
}

const fundManagerSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const fundManagerFundManagersCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundManagersCreateResponse> => {
  data = fundManagerSchemaResponseTransformer(data)
  return data
}

const fundManagerPolicySchemaResponseTransformer = (data: any) => {
  data.update_time = new Date(data.update_time)
  return data
}

const fundManagerPolicyListResponseSchemaResponseTransformer = (data: any) => {
  data.policies = data.policies.map((item: any) => fundManagerPolicySchemaResponseTransformer(item))
  return data
}

export const fundManagerFundManagersPoliciesRetrieveResponseTransformer = async (
  data: any
): Promise<FundManagerFundManagersPoliciesRetrieveResponse> => {
  data = fundManagerPolicyListResponseSchemaResponseTransformer(data)
  return data
}

export const fundManagerFundManagersPoliciesCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundManagersPoliciesCreateResponse> => {
  data = fundManagerPolicySchemaResponseTransformer(data)
  return data
}

export const fundManagerFundManagersRetrieveResponseTransformer = async (
  data: any
): Promise<FundManagerFundManagersRetrieveResponse> => {
  data = fundManagerSchemaResponseTransformer(data)
  return data
}

export const fundManagerFundManagersUpdateResponseTransformer = async (
  data: any
): Promise<FundManagerFundManagersUpdateResponse> => {
  data = fundManagerSchemaResponseTransformer(data)
  return data
}

const paginatedFundManagerListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => fundManagerSchemaResponseTransformer(item))
  return data
}

export const fundManagerFundManagersSearchCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundManagersSearchCreateResponse> => {
  data = paginatedFundManagerListSchemaResponseTransformer(data)
  return data
}

const fundVariantSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const fundManagerFundVariantsCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundVariantsCreateResponse> => {
  data = fundVariantSchemaResponseTransformer(data)
  return data
}

export const fundManagerFundVariantsRetrieveResponseTransformer = async (
  data: any
): Promise<FundManagerFundVariantsRetrieveResponse> => {
  data = fundVariantSchemaResponseTransformer(data)
  return data
}

export const fundManagerFundVariantsUpdateResponseTransformer = async (
  data: any
): Promise<FundManagerFundVariantsUpdateResponse> => {
  data = fundVariantSchemaResponseTransformer(data)
  return data
}

const paginatedFundVariantListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => fundVariantSchemaResponseTransformer(item))
  return data
}

export const fundManagerFundVariantsSearchCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundVariantsSearchCreateResponse> => {
  data = paginatedFundVariantListSchemaResponseTransformer(data)
  return data
}

const fundSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const fundManagerFundsCreateResponseTransformer = async (data: any): Promise<FundManagerFundsCreateResponse> => {
  data = fundSchemaResponseTransformer(data)
  return data
}

const fundQuantificationSnapshotSchemaResponseTransformer = (data: any) => {
  data.valid_time = new Date(data.valid_time)
  data.create_time = new Date(data.create_time)
  return data
}

export const fundManagerFundsQuantificationSnapshotsCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundsQuantificationSnapshotsCreateResponse> => {
  data = fundQuantificationSnapshotSchemaResponseTransformer(data)
  return data
}

export const fundManagerFundsRetrieveResponseTransformer = async (
  data: any
): Promise<FundManagerFundsRetrieveResponse> => {
  data = fundSchemaResponseTransformer(data)
  return data
}

export const fundManagerFundsUpdateResponseTransformer = async (data: any): Promise<FundManagerFundsUpdateResponse> => {
  data = fundSchemaResponseTransformer(data)
  return data
}

const paginatedFundListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => fundSchemaResponseTransformer(item))
  return data
}

export const fundManagerFundsSearchCreateResponseTransformer = async (
  data: any
): Promise<FundManagerFundsSearchCreateResponse> => {
  data = paginatedFundListSchemaResponseTransformer(data)
  return data
}

const providerSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const paginatedProviderListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => providerSchemaResponseTransformer(item))
  return data
}

export const fundManagerProvidersListResponseTransformer = async (
  data: any
): Promise<FundManagerProvidersListResponse> => {
  data = paginatedProviderListSchemaResponseTransformer(data)
  return data
}

export const fundManagerProvidersCreateResponseTransformer = async (
  data: any
): Promise<FundManagerProvidersCreateResponse> => {
  data = providerSchemaResponseTransformer(data)
  return data
}

export const fundManagerProvidersRetrieveResponseTransformer = async (
  data: any
): Promise<FundManagerProvidersRetrieveResponse> => {
  data = providerSchemaResponseTransformer(data)
  return data
}

export const fundManagerProvidersUpdateResponseTransformer = async (
  data: any
): Promise<FundManagerProvidersUpdateResponse> => {
  data = providerSchemaResponseTransformer(data)
  return data
}

const fundManagerPublicSecurityIdSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const fundManagerPublicSecurityIdsCreateResponseTransformer = async (
  data: any
): Promise<FundManagerPublicSecurityIdsCreateResponse> => {
  data = fundManagerPublicSecurityIdSchemaResponseTransformer(data)
  return data
}

const paginatedFundManagerPublicSecurityIdListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => fundManagerPublicSecurityIdSchemaResponseTransformer(item))
  return data
}

export const fundManagerPublicSecurityIdsSearchCreateResponseTransformer = async (
  data: any
): Promise<FundManagerPublicSecurityIdsSearchCreateResponse> => {
  data = paginatedFundManagerPublicSecurityIdListSchemaResponseTransformer(data)
  return data
}

const paginatedFundQuantificationSnapshotListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => fundQuantificationSnapshotSchemaResponseTransformer(item))
  return data
}

export const fundManagerQuantificationSnapshotsSearchCreateResponseTransformer = async (
  data: any
): Promise<FundManagerQuantificationSnapshotsSearchCreateResponse> => {
  data = paginatedFundQuantificationSnapshotListSchemaResponseTransformer(data)
  return data
}

const meetingSchemaResponseTransformer = (data: any) => {
  data.meeting_date = new Date(data.meeting_date)
  data.action_deadline = new Date(data.action_deadline)
  return data
}

const paginatedMeetingListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => meetingSchemaResponseTransformer(item))
  return data
}

export const institutionalMeetingsearchListResponseTransformer = async (
  data: any
): Promise<InstitutionalMeetingsearchListResponse> => {
  data = paginatedMeetingListSchemaResponseTransformer(data)
  return data
}

const fiscalYearSchemaResponseTransformer = (data: any) => {
  data.period_end_date = new Date(data.period_end_date)
  if (data.statement_date) {
    data.statement_date = new Date(data.statement_date)
  }
  if (data.announced_date) {
    data.announced_date = new Date(data.announced_date)
  }
  if (data.basic_weighted_avg_shares) {
    data.basic_weighted_avg_shares = BigInt(data.basic_weighted_avg_shares.toString())
  }
  if (data.period_end_shares) {
    data.period_end_shares = BigInt(data.period_end_shares.toString())
  }
  if (data.split_adjustment_date) {
    data.split_adjustment_date = new Date(data.split_adjustment_date)
  }
  if (data.esg_received_date) {
    data.esg_received_date = new Date(data.esg_received_date)
  }
  data.create_time = new Date(data.create_time)
  return data
}

const paginatedFiscalYearListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => fiscalYearSchemaResponseTransformer(item))
  return data
}

export const issuerFiscalYearsSearchCreateResponseTransformer = async (
  data: any
): Promise<IssuerFiscalYearsSearchCreateResponse> => {
  data = paginatedFiscalYearListSchemaResponseTransformer(data)
  return data
}

const issuerInstrumentSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const issuerInstrumentsRetrieveResponseTransformer = async (
  data: any
): Promise<IssuerInstrumentsRetrieveResponse> => {
  data = issuerInstrumentSchemaResponseTransformer(data)
  return data
}

const outstandingSharesSchemaResponseTransformer = (data: any) => {
  data.valid_date = new Date(data.valid_date)
  return data
}

export const issuerInstrumentsOutstandingSharesRetrieveResponseTransformer = async (
  data: any
): Promise<IssuerInstrumentsOutstandingSharesRetrieveResponse> => {
  data = outstandingSharesSchemaResponseTransformer(data)
  return data
}

const totalShareholderReturnSchemaResponseTransformer = (data: any) => {
  data.valid_date = new Date(data.valid_date)
  return data
}

const totalShareholderReturnListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => totalShareholderReturnSchemaResponseTransformer(item))
  return data
}

export const issuerInstrumentsTotalShareholderReturnRetrieveResponseTransformer = async (
  data: any
): Promise<IssuerInstrumentsTotalShareholderReturnRetrieveResponse> => {
  data = totalShareholderReturnListSchemaResponseTransformer(data)
  return data
}

const paginatedIssuerInstrumentListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => issuerInstrumentSchemaResponseTransformer(item))
  return data
}

export const issuerInstrumentsSearchCreateResponseTransformer = async (
  data: any
): Promise<IssuerInstrumentsSearchCreateResponse> => {
  data = paginatedIssuerInstrumentListSchemaResponseTransformer(data)
  return data
}

const issuerSchemaResponseTransformer = (data: any) => {
  if (data.first_public_date) {
    data.first_public_date = new Date(data.first_public_date)
  }
  if (data.despac_date) {
    data.despac_date = new Date(data.despac_date)
  }
  data.create_time = new Date(data.create_time)
  return data
}

export const issuerIssuersRetrieveResponseTransformer = async (data: any): Promise<IssuerIssuersRetrieveResponse> => {
  data = issuerSchemaResponseTransformer(data)
  return data
}

const marketCapitalisationSchemaResponseTransformer = (data: any) => {
  data.valid_date = new Date(data.valid_date)
  return data
}

export const issuerIssuersMarketCapitalisationRetrieveResponseTransformer = async (
  data: any
): Promise<IssuerIssuersMarketCapitalisationRetrieveResponse> => {
  data = marketCapitalisationSchemaResponseTransformer(data)
  return data
}

const paginatedIssuerListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => issuerSchemaResponseTransformer(item))
  return data
}

export const issuerIssuersSearchCreateResponseTransformer = async (
  data: any
): Promise<IssuerIssuersSearchCreateResponse> => {
  data = paginatedIssuerListSchemaResponseTransformer(data)
  return data
}

const paginatedMarketCapitalisationListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => marketCapitalisationSchemaResponseTransformer(item))
  return data
}

export const issuerMarketCapitalisationsSearchCreateResponseTransformer = async (
  data: any
): Promise<IssuerMarketCapitalisationsSearchCreateResponse> => {
  data = paginatedMarketCapitalisationListSchemaResponseTransformer(data)
  return data
}

const paginatedOutstandingSharesListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => outstandingSharesSchemaResponseTransformer(item))
  return data
}

export const issuerOutstandingSharesSearchCreateResponseTransformer = async (
  data: any
): Promise<IssuerOutstandingSharesSearchCreateResponse> => {
  data = paginatedOutstandingSharesListSchemaResponseTransformer(data)
  return data
}

const paginatedTotalShareholderReturnListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => totalShareholderReturnSchemaResponseTransformer(item))
  return data
}

export const issuerTotalShareholderReturnsSearchCreateResponseTransformer = async (
  data: any
): Promise<IssuerTotalShareholderReturnsSearchCreateResponse> => {
  data = paginatedTotalShareholderReturnListSchemaResponseTransformer(data)
  return data
}

const deadlinesSchemaResponseTransformer = (data: any) => {
  data.investor_voting_deadline = new Date(data.investor_voting_deadline)
  data.vote_allocation_time = new Date(data.vote_allocation_time)
  data.vote_allocation_window_start_time = new Date(data.vote_allocation_window_start_time)
  data.created_at = new Date(data.created_at)
  return data
}

const ballotSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.version_create_time = new Date(data.version_create_time)
  if (data.cancel_time) {
    data.cancel_time = new Date(data.cancel_time)
  }
  data.eligible_shares = BigInt(data.eligible_shares.toString())
  data.submission_deadline = new Date(data.submission_deadline)
  data.valid_time = new Date(data.valid_time)
  if (data.deadlines) {
    data.deadlines = deadlinesSchemaResponseTransformer(data.deadlines)
  }
  return data
}

const paginatedBallotListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => ballotSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryBallotsVersionsListResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryBallotsVersionsListResponse> => {
  data = paginatedBallotListSchemaResponseTransformer(data)
  return data
}

const ballotListResponseSchemaResponseTransformer = (data: any) => {
  data.ballots = data.ballots.map((item: any) => ballotSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryBallotsFetchByVersionIdsCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryBallotsFetchByVersionIdsCreateResponse> => {
  data = ballotListResponseSchemaResponseTransformer(data)
  return data
}

export const proxyIntermediaryBallotsProxymityStaleProposalSetListResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryBallotsProxymityStaleProposalSetListResponse> => {
  data = paginatedBallotListSchemaResponseTransformer(data)
  return data
}

export const proxyIntermediaryBallotsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryBallotsSearchCreateResponse> => {
  data = paginatedBallotListSchemaResponseTransformer(data)
  return data
}

const upsertResponseSchemaResponseTransformer = (data: any) => {
  data.ballot = ballotSchemaResponseTransformer(data.ballot)
  return data
}

export const proxyIntermediaryBallotsUpsertCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryBallotsUpsertCreateResponse> => {
  data = upsertResponseSchemaResponseTransformer(data)
  return data
}

const custodyAccountSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const proxyIntermediaryCustodyAccountsCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryCustodyAccountsCreateResponse> => {
  data = custodyAccountSchemaResponseTransformer(data)
  return data
}

export const proxyIntermediaryCustodyAccountsRetrieveResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryCustodyAccountsRetrieveResponse> => {
  data = custodyAccountSchemaResponseTransformer(data)
  return data
}

export const proxyIntermediaryCustodyAccountsPartialUpdateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryCustodyAccountsPartialUpdateResponse> => {
  data = custodyAccountSchemaResponseTransformer(data)
  return data
}

export const proxyIntermediaryCustodyAccountsUpdateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryCustodyAccountsUpdateResponse> => {
  data = custodyAccountSchemaResponseTransformer(data)
  return data
}

const paginatedCustodyAccountListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => custodyAccountSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryCustodyAccountsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryCustodyAccountsSearchCreateResponse> => {
  data = paginatedCustodyAccountListSchemaResponseTransformer(data)
  return data
}

const proxyIntermediaryProposalSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const createProposalsResponseSchemaResponseTransformer = (data: any) => {
  data.proposals = data.proposals.map((item: any) => proxyIntermediaryProposalSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryProposalsCreateCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProposalsCreateCreateResponse> => {
  data = createProposalsResponseSchemaResponseTransformer(data)
  return data
}

const piProposalCategorySearchResultSchemaResponseTransformer = (data: any) => {
  data.meeting_time = new Date(data.meeting_time)
  return data
}

const paginatedPiProposalCategorySearchResultListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => piProposalCategorySearchResultSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryProposalsProposalCategorySearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProposalsProposalCategorySearchCreateResponse> => {
  data = paginatedPiProposalCategorySearchResultListSchemaResponseTransformer(data)
  return data
}

const paginatedProxyIntermediaryProposalListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proxyIntermediaryProposalSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryProposalsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProposalsSearchCreateResponse> => {
  data = paginatedProxyIntermediaryProposalListSchemaResponseTransformer(data)
  return data
}

const proxyIntermediarySchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const paginatedProxyIntermediaryListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proxyIntermediarySchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryProxyIntermediariesSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyIntermediariesSearchCreateResponse> => {
  data = paginatedProxyIntermediaryListSchemaResponseTransformer(data)
  return data
}

const proxyIntermediaryMeetingAuditEventSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const paginatedProxyIntermediaryMeetingAuditEventListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proxyIntermediaryMeetingAuditEventSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponse> => {
  data = paginatedProxyIntermediaryMeetingAuditEventListSchemaResponseTransformer(data)
  return data
}

const proxyIntermediaryMeetingSchemaResponseTransformer = (data: any) => {
  data.meeting_time = new Date(data.meeting_time)
  data.submission_deadline = new Date(data.submission_deadline)
  if (data.record_date) {
    data.record_date = new Date(data.record_date)
  }
  data.create_time = new Date(data.create_time)
  if (data.cancel_time) {
    data.cancel_time = new Date(data.cancel_time)
  }
  data.valid_time = new Date(data.valid_time)
  return data
}

const proxyIntermediaryMeetingBatchCancelResponseSchemaResponseTransformer = (data: any) => {
  data.proxy_intermediary_meetings = data.proxy_intermediary_meetings.map((item: any) =>
    proxyIntermediaryMeetingSchemaResponseTransformer(item)
  )
  return data
}

export const proxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponse> => {
  data = proxyIntermediaryMeetingBatchCancelResponseSchemaResponseTransformer(data)
  return data
}

const proxyIntermediaryMeetingResponseSchemaResponseTransformer = (data: any) => {
  data.proxy_intermediary_meeting = proxyIntermediaryMeetingSchemaResponseTransformer(data.proxy_intermediary_meeting)
  return data
}

export const proxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponse> => {
  data = proxyIntermediaryMeetingResponseSchemaResponseTransformer(data)
  return data
}

const paginatedProxyIntermediaryMeetingListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proxyIntermediaryMeetingSchemaResponseTransformer(item))
  return data
}

export const proxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponse> => {
  data = paginatedProxyIntermediaryMeetingListSchemaResponseTransformer(data)
  return data
}

export const proxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponseTransformer =
  async (
    data: any
  ): Promise<ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponse> => {
    data = proxyIntermediaryMeetingResponseSchemaResponseTransformer(data)
    return data
  }

const proxyIntermediaryMeetingUpsertResponseSchemaResponseTransformer = (data: any) => {
  data.proxy_intermediary_meeting = proxyIntermediaryMeetingSchemaResponseTransformer(data.proxy_intermediary_meeting)
  return data
}

export const proxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponse> => {
  data = proxyIntermediaryMeetingUpsertResponseSchemaResponseTransformer(data)
  return data
}

const proxyEdgeVoteSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.valid_time = new Date(data.valid_time)
  return data
}

const proxyEdgeVoteResponseSchemaResponseTransformer = (data: any) => {
  data.proxyedge_vote = proxyEdgeVoteSchemaResponseTransformer(data.proxyedge_vote)
  return data
}

export const proxyIntermediaryProxyedgeVotesCreateCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyedgeVotesCreateCreateResponse> => {
  data = proxyEdgeVoteResponseSchemaResponseTransformer(data)
  return data
}

export const proxyIntermediaryProxyedgeVotesFetchLatestCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxyedgeVotesFetchLatestCreateResponse> => {
  data = proxyEdgeVoteResponseSchemaResponseTransformer(data)
  return data
}

const proxymityVoteInstructionSchemaResponseTransformer = (data: any) => {
  data.vote_for = BigInt(data.vote_for.toString())
  data.vote_against = BigInt(data.vote_against.toString())
  data.vote_abstain = BigInt(data.vote_abstain.toString())
  data.vote_withhold = BigInt(data.vote_withhold.toString())
  data.vote_with_management = BigInt(data.vote_with_management.toString())
  data.vote_against_management = BigInt(data.vote_against_management.toString())
  data.vote_discretionary = BigInt(data.vote_discretionary.toString())
  data.vote_one_year = BigInt(data.vote_one_year.toString())
  data.vote_two_years = BigInt(data.vote_two_years.toString())
  data.vote_three_years = BigInt(data.vote_three_years.toString())
  data.vote_no_action = BigInt(data.vote_no_action.toString())
  data.vote_blank = BigInt(data.vote_blank.toString())
  return data
}

const proxymityVoteSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.valid_time = new Date(data.valid_time)
  data.instructed_balance = BigInt(data.instructed_balance.toString())
  data.vote_per_agenda_resolution = data.vote_per_agenda_resolution.map((item: any) =>
    proxymityVoteInstructionSchemaResponseTransformer(item)
  )
  return data
}

const proxymityVoteResponseSchemaResponseTransformer = (data: any) => {
  data.proxymity_vote = proxymityVoteSchemaResponseTransformer(data.proxymity_vote)
  return data
}

export const proxyIntermediaryProxymityVotesCreateCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxymityVotesCreateCreateResponse> => {
  data = proxymityVoteResponseSchemaResponseTransformer(data)
  return data
}

export const proxyIntermediaryProxymityVotesFetchLatestCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryProxymityVotesFetchLatestCreateResponse> => {
  data = proxymityVoteResponseSchemaResponseTransformer(data)
  return data
}

const voteStatusSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.valid_time = new Date(data.valid_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  return data
}

const voteStatusUpsertResponseSchemaResponseTransformer = (data: any) => {
  data.vote_status = voteStatusSchemaResponseTransformer(data.vote_status)
  return data
}

export const proxyIntermediaryVoteStatusesUpsertCreateResponseTransformer = async (
  data: any
): Promise<ProxyIntermediaryVoteStatusesUpsertCreateResponse> => {
  data = voteStatusUpsertResponseSchemaResponseTransformer(data)
  return data
}

const ballotEntitlementSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  if (data.invalid_time) {
    data.invalid_time = new Date(data.invalid_time)
  }
  return data
}

const paginatedBallotEntitlementListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => ballotEntitlementSchemaResponseTransformer(item))
  return data
}

export const proxyvotingEntitlementsListResponseTransformer = async (
  data: any
): Promise<ProxyvotingEntitlementsListResponse> => {
  data = paginatedBallotEntitlementListSchemaResponseTransformer(data)
  return data
}

const fundManagerPolicySiiSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  data.valid_from = new Date(data.valid_from)
  if (data.valid_to) {
    data.valid_to = new Date(data.valid_to)
  }
  return data
}

const fundManagerPolicySiiResponseSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) => fundManagerPolicySiiSchemaResponseTransformer(item))
  return data
}

export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponse> => {
  data = fundManagerPolicySiiResponseSchemaResponseTransformer(data)
  return data
}

const paginatedFundManagerPolicySiiListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => fundManagerPolicySiiSchemaResponseTransformer(item))
  return data
}

export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponse> => {
  data = paginatedFundManagerPolicySiiListSchemaResponseTransformer(data)
  return data
}

const fundManagerSupportedVotingPolicyHistoricalSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  if (data.history_date) {
    data.history_date = new Date(data.history_date)
  }
  return data
}

const paginatedFundManagerSupportedVotingPolicyHistoricalListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) =>
    fundManagerSupportedVotingPolicyHistoricalSchemaResponseTransformer(item)
  )
  return data
}

export const proxyvotingFundManagerSupportedPoliciesListResponseTransformer = async (
  data: any
): Promise<ProxyvotingFundManagerSupportedPoliciesListResponse> => {
  data = paginatedFundManagerSupportedVotingPolicyHistoricalListSchemaResponseTransformer(data)
  return data
}

const fundManagerSupportedVotingPolicySchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const fundManagerSupportedVotingPolicyBatchUpsertResponseSchemaResponseTransformer = (data: any) => {
  data.policies = data.policies.map((item: any) => fundManagerSupportedVotingPolicySchemaResponseTransformer(item))
  return data
}

export const proxyvotingFundManagerSupportedPoliciesCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingFundManagerSupportedPoliciesCreateResponse> => {
  data = fundManagerSupportedVotingPolicyBatchUpsertResponseSchemaResponseTransformer(data)
  return data
}

const componentDiffSchemaResponseTransformer = (data: any) => {
  data.start_date = new Date(data.start_date)
  return data
}

const compositionDifferenceResponseSchemaResponseTransformer = (data: any) => {
  data.components = data.components.map((item: any) => componentDiffSchemaResponseTransformer(item))
  return data
}

export const proxyvotingInvestorCompositionsDifferenceListResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorCompositionsDifferenceListResponse> => {
  data = data.map((item: any) => compositionDifferenceResponseSchemaResponseTransformer(item))
  return data
}

const investorRulesEngineSchemaResponseTransformer = (data: any) => {
  data.created_at = new Date(data.created_at)
  data.updated_at = new Date(data.updated_at)
  return data
}

export const proxyvotingInvestorCompositionsRulesEngineRetrieveResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorCompositionsRulesEngineRetrieveResponse> => {
  data = investorRulesEngineSchemaResponseTransformer(data)
  return data
}

export const proxyvotingInvestorCompositionsRulesEngineUpdateResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorCompositionsRulesEngineUpdateResponse> => {
  data = investorRulesEngineSchemaResponseTransformer(data)
  return data
}

const investorPolicySiiSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  data.valid_from = new Date(data.valid_from)
  if (data.valid_to) {
    data.valid_to = new Date(data.valid_to)
  }
  return data
}

const investorPolicySiiResponseSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) => investorPolicySiiSchemaResponseTransformer(item))
  return data
}

export const proxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponse> => {
  data = investorPolicySiiResponseSchemaResponseTransformer(data)
  return data
}

const paginatedInvestorPolicySiiListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => investorPolicySiiSchemaResponseTransformer(item))
  return data
}

export const proxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponse> => {
  data = paginatedInvestorPolicySiiListSchemaResponseTransformer(data)
  return data
}

const investorSupportedIssuedInstrumentSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  data.valid_from = new Date(data.valid_from)
  if (data.valid_to) {
    data.valid_to = new Date(data.valid_to)
  }
  return data
}

const investorSiiResponseSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) => investorSupportedIssuedInstrumentSchemaResponseTransformer(item))
  return data
}

export const proxyvotingInvestorSupportedIssuedInstrumentsCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponse> => {
  data = investorSiiResponseSchemaResponseTransformer(data)
  return data
}

const paginatedInvestorSupportedIssuedInstrumentListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => investorSupportedIssuedInstrumentSchemaResponseTransformer(item))
  return data
}

export const proxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponse> => {
  data = paginatedInvestorSupportedIssuedInstrumentListSchemaResponseTransformer(data)
  return data
}

const meetingBallotSourceSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  if (data.invalid_time) {
    data.invalid_time = new Date(data.invalid_time)
  }
  return data
}

const paginatedMeetingBallotSourceListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => meetingBallotSourceSchemaResponseTransformer(item))
  return data
}

export const proxyvotingMeetingBallotSourcesListResponseTransformer = async (
  data: any
): Promise<ProxyvotingMeetingBallotSourcesListResponse> => {
  data = paginatedMeetingBallotSourceListSchemaResponseTransformer(data)
  return data
}

const meetingBallotSchemaResponseTransformer = (data: any) => {
  data.earliest_voting_deadline = new Date(data.earliest_voting_deadline)
  data.latest_voting_deadline = new Date(data.latest_voting_deadline)
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  if (data.complete_time) {
    data.complete_time = new Date(data.complete_time)
  }
  return data
}

const paginatedMeetingBallotListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => meetingBallotSchemaResponseTransformer(item))
  return data
}

export const proxyvotingMeetingBallotsListResponseTransformer = async (
  data: any
): Promise<ProxyvotingMeetingBallotsListResponse> => {
  data = paginatedMeetingBallotListSchemaResponseTransformer(data)
  return data
}

const piBallotSearchSchemaResponseTransformer = (data: any) => {
  data.vote_deadline = new Date(data.vote_deadline)
  return data
}

const paginatedPiBallotSearchListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => piBallotSearchSchemaResponseTransformer(item))
  return data
}

export const proxyvotingPiballotsFilterListResponseTransformer = async (
  data: any
): Promise<ProxyvotingPiballotsFilterListResponse> => {
  data = paginatedPiBallotSearchListSchemaResponseTransformer(data)
  return data
}

const piMeetingSearchSchemaResponseTransformer = (data: any) => {
  data.meeting_time = new Date(data.meeting_time)
  data.submission_deadline = new Date(data.submission_deadline)
  if (data.record_date) {
    data.record_date = new Date(data.record_date)
  }
  if (data.cancel_time) {
    data.cancel_time = new Date(data.cancel_time)
  }
  data.meeting_create_time = new Date(data.meeting_create_time)
  if (data.latest_valid_to_sii) {
    data.latest_valid_to_sii = new Date(data.latest_valid_to_sii)
  }
  if (data.earliest_ballot_submission_deadline) {
    data.earliest_ballot_submission_deadline = new Date(data.earliest_ballot_submission_deadline)
  }
  return data
}

const paginatedPiMeetingSearchListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => piMeetingSearchSchemaResponseTransformer(item))
  return data
}

export const proxyvotingPimeetingsFilterListResponseTransformer = async (
  data: any
): Promise<ProxyvotingPimeetingsFilterListResponse> => {
  data = paginatedPiMeetingSearchListSchemaResponseTransformer(data)
  return data
}

const rulesEngineDefinitionSchemaResponseTransformer = (data: any) => {
  data.valid_from = new Date(data.valid_from)
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const paginatedRulesEngineDefinitionListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => rulesEngineDefinitionSchemaResponseTransformer(item))
  return data
}

export const proxyvotingRulesEngineDefinitionsListResponseTransformer = async (
  data: any
): Promise<ProxyvotingRulesEngineDefinitionsListResponse> => {
  data = paginatedRulesEngineDefinitionListSchemaResponseTransformer(data)
  return data
}

export const proxyvotingRulesEngineDefinitionsCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingRulesEngineDefinitionsCreateResponse> => {
  data = rulesEngineDefinitionSchemaResponseTransformer(data)
  return data
}

const rulesEngineRuleSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

const paginatedRulesEngineRuleListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => rulesEngineRuleSchemaResponseTransformer(item))
  return data
}

export const proxyvotingRulesEngineDefinitionsRulesListResponseTransformer = async (
  data: any
): Promise<ProxyvotingRulesEngineDefinitionsRulesListResponse> => {
  data = paginatedRulesEngineRuleListSchemaResponseTransformer(data)
  return data
}

export const proxyvotingRulesEngineDefinitionsRulesCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingRulesEngineDefinitionsRulesCreateResponse> => {
  data = rulesEngineRuleSchemaResponseTransformer(data)
  return data
}

export const proxyvotingRulesEngineDefinitionsRulesUpdateResponseTransformer = async (
  data: any
): Promise<ProxyvotingRulesEngineDefinitionsRulesUpdateResponse> => {
  data = rulesEngineRuleSchemaResponseTransformer(data)
  return data
}

export const proxyvotingRulesEngineDefinitionsRetrieveResponseTransformer = async (
  data: any
): Promise<ProxyvotingRulesEngineDefinitionsRetrieveResponse> => {
  data = rulesEngineDefinitionSchemaResponseTransformer(data)
  return data
}

const splitVoteInstructionProposalOverwriteSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  return data
}

export const proxyvotingSviProposalOverwriteCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingSviProposalOverwriteCreateResponse> => {
  data = splitVoteInstructionProposalOverwriteSchemaResponseTransformer(data)
  return data
}

const splitVoteInstructionSubmissionAcknowledgementSchemaResponseTransformer = (data: any) => {
  data.acknowledge_time = new Date(data.acknowledge_time)
  data.create_time = new Date(data.create_time)
  return data
}

const splitVoteInstructionSubmissionSchemaResponseTransformer = (data: any) => {
  data.submit_time = new Date(data.submit_time)
  if (data.check_time) {
    data.check_time = new Date(data.check_time)
  }
  if (data.acknowledgement) {
    data.acknowledgement = splitVoteInstructionSubmissionAcknowledgementSchemaResponseTransformer(data.acknowledgement)
  }
  return data
}

const submitVoteResponseSchemaResponseTransformer = (data: any) => {
  data.submission = splitVoteInstructionSubmissionSchemaResponseTransformer(data.submission)
  return data
}

export const proxyvotingSviSubmitVoteCreateResponseTransformer = async (
  data: any
): Promise<ProxyvotingSviSubmitVoteCreateResponse> => {
  data = submitVoteResponseSchemaResponseTransformer(data)
  return data
}

const tenantSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const tenancyTenantsCreateResponseTransformer = async (data: any): Promise<TenancyTenantsCreateResponse> => {
  data = tenantSchemaResponseTransformer(data)
  return data
}

export const tenancyTenantsRetrieveResponseTransformer = async (data: any): Promise<TenancyTenantsRetrieveResponse> => {
  data = tenantSchemaResponseTransformer(data)
  return data
}

export const tenancyTenantsUpdateResponseTransformer = async (data: any): Promise<TenancyTenantsUpdateResponse> => {
  data = tenantSchemaResponseTransformer(data)
  return data
}

const paginatedTenantListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => tenantSchemaResponseTransformer(item))
  return data
}

export const tenancyTenantsSearchCreateResponseTransformer = async (
  data: any
): Promise<TenancyTenantsSearchCreateResponse> => {
  data = paginatedTenantListSchemaResponseTransformer(data)
  return data
}

const userSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const tenancyUsersCreateResponseTransformer = async (data: any): Promise<TenancyUsersCreateResponse> => {
  data = userSchemaResponseTransformer(data)
  return data
}

export const tenancyUsersRetrieveResponseTransformer = async (data: any): Promise<TenancyUsersRetrieveResponse> => {
  data = userSchemaResponseTransformer(data)
  return data
}

export const tenancyUsersUpdateResponseTransformer = async (data: any): Promise<TenancyUsersUpdateResponse> => {
  data = userSchemaResponseTransformer(data)
  return data
}

const paginatedUserListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => userSchemaResponseTransformer(item))
  return data
}

export const tenancyUsersSearchCreateResponseTransformer = async (
  data: any
): Promise<TenancyUsersSearchCreateResponse> => {
  data = paginatedUserListSchemaResponseTransformer(data)
  return data
}

const auditEventSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const paginatedAuditEventListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => auditEventSchemaResponseTransformer(item))
  return data
}

export const transparencyAuditEventsSearchCreateResponseTransformer = async (
  data: any
): Promise<TransparencyAuditEventsSearchCreateResponse> => {
  data = paginatedAuditEventListSchemaResponseTransformer(data)
  return data
}

const externalMeetingIdSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const transparencyExternalMeetingIdsCreateResponseTransformer = async (
  data: any
): Promise<TransparencyExternalMeetingIdsCreateResponse> => {
  data = externalMeetingIdSchemaResponseTransformer(data)
  return data
}

const proxySubmissionSchemaResponseTransformer = (data: any) => {
  if (data.proxy_edge_deadline) {
    data.proxy_edge_deadline = new Date(data.proxy_edge_deadline)
  }
  return data
}

const generalMeetingSchemaResponseTransformer = (data: any) => {
  data.meeting_date = new Date(data.meeting_date)
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  if (data.invalid_time) {
    data.invalid_time = new Date(data.invalid_time)
  }
  if (data.announcement_time) {
    data.announcement_time = new Date(data.announcement_time)
  }
  if (data.record_date) {
    data.record_date = new Date(data.record_date)
  }
  if (data.edi_record_date) {
    data.edi_record_date = new Date(data.edi_record_date)
  }
  if (data.voting_enabled_time) {
    data.voting_enabled_time = new Date(data.voting_enabled_time)
  }
  if (data.disable_edi_agenda_pipeline_updates_time) {
    data.disable_edi_agenda_pipeline_updates_time = new Date(data.disable_edi_agenda_pipeline_updates_time)
  }
  if (data.proxy_submission) {
    data.proxy_submission = proxySubmissionSchemaResponseTransformer(data.proxy_submission)
  }
  return data
}

export const transparencyGeneralMeetingsCreateResponseTransformer = async (
  data: any
): Promise<TransparencyGeneralMeetingsCreateResponse> => {
  data = generalMeetingSchemaResponseTransformer(data)
  return data
}

export const transparencyGeneralMeetingsRetrieveResponseTransformer = async (
  data: any
): Promise<TransparencyGeneralMeetingsRetrieveResponse> => {
  data = generalMeetingSchemaResponseTransformer(data)
  return data
}

export const transparencyGeneralMeetingsPartialUpdateResponseTransformer = async (
  data: any
): Promise<TransparencyGeneralMeetingsPartialUpdateResponse> => {
  data = generalMeetingSchemaResponseTransformer(data)
  return data
}

const paginatedGeneralMeetingListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => generalMeetingSchemaResponseTransformer(item))
  return data
}

export const transparencyGeneralMeetingsSearchCreateResponseTransformer = async (
  data: any
): Promise<TransparencyGeneralMeetingsSearchCreateResponse> => {
  data = paginatedGeneralMeetingListSchemaResponseTransformer(data)
  return data
}

const organizationSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const transparencyOrganizationsCreateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsCreateResponse> => {
  data = organizationSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsRetrieveResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsRetrieveResponse> => {
  data = organizationSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsPartialUpdateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsPartialUpdateResponse> => {
  data = organizationSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsUpdateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsUpdateResponse> => {
  data = organizationSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsLogoCreateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsLogoCreateResponse> => {
  data = organizationSchemaResponseTransformer(data)
  return data
}

const proposalVotesSchemaResponseTransformer = (data: any) => {
  if (data.for_votes) {
    data.for_votes = BigInt(data.for_votes.toString())
  }
  if (data.against_votes) {
    data.against_votes = BigInt(data.against_votes.toString())
  }
  if (data.abstention_votes) {
    data.abstention_votes = BigInt(data.abstention_votes.toString())
  }
  if (data.broker_non_votes) {
    data.broker_non_votes = BigInt(data.broker_non_votes.toString())
  }
  if (data.withheld_votes) {
    data.withheld_votes = BigInt(data.withheld_votes.toString())
  }
  if (data.one_year_votes) {
    data.one_year_votes = BigInt(data.one_year_votes.toString())
  }
  if (data.two_years_votes) {
    data.two_years_votes = BigInt(data.two_years_votes.toString())
  }
  if (data.three_years_votes) {
    data.three_years_votes = BigInt(data.three_years_votes.toString())
  }
  return data
}

const proposalOutcomeSchemaResponseTransformer = (data: any) => {
  if (data.votes) {
    data.votes = proposalVotesSchemaResponseTransformer(data.votes)
  }
  data.create_time = new Date(data.create_time)
  return data
}

const proposalSchemaResponseTransformer = (data: any) => {
  if (data.outcome) {
    data.outcome = proposalOutcomeSchemaResponseTransformer(data.outcome)
  }
  if (data.withdraw_time) {
    data.withdraw_time = new Date(data.withdraw_time)
  }
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  return data
}

export const transparencyOrganizationsGeneralMeetingsProposalsCreateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsGeneralMeetingsProposalsCreateResponse> => {
  data = proposalSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsGeneralMeetingsProposalsRetrieveResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponse> => {
  data = proposalSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponse> => {
  data = proposalSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsGeneralMeetingsProposalsUpdateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponse> => {
  data = proposalSchemaResponseTransformer(data)
  return data
}

const paginatedProposalListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proposalSchemaResponseTransformer(item))
  return data
}

export const transparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponse> => {
  data = paginatedProposalListSchemaResponseTransformer(data)
  return data
}

export const transparencyOrganizationsGetByIdentifierCreateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsGetByIdentifierCreateResponse> => {
  data = organizationSchemaResponseTransformer(data)
  return data
}

const paginatedOrganizationListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => organizationSchemaResponseTransformer(item))
  return data
}

export const transparencyOrganizationsSearchCreateResponseTransformer = async (
  data: any
): Promise<TransparencyOrganizationsSearchCreateResponse> => {
  data = paginatedOrganizationListSchemaResponseTransformer(data)
  return data
}

export const transparencyProposalsFetchCreateResponseTransformer = async (
  data: any
): Promise<TransparencyProposalsFetchCreateResponse> => {
  data = paginatedProposalListSchemaResponseTransformer(data)
  return data
}

const publicSecurityIdSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

const paginatedPublicSecurityIdListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => publicSecurityIdSchemaResponseTransformer(item))
  return data
}

export const transparencyPublicSecurityIdsSearchCreateResponseTransformer = async (
  data: any
): Promise<TransparencyPublicSecurityIdsSearchCreateResponse> => {
  data = paginatedPublicSecurityIdListSchemaResponseTransformer(data)
  return data
}

export const votingOperationsPiballotsFilterListResponseTransformer = async (
  data: any
): Promise<VotingOperationsPiballotsFilterListResponse> => {
  data = paginatedPiBallotSearchListSchemaResponseTransformer(data)
  return data
}

export const votingOperationsPimeetingsFilterListResponseTransformer = async (
  data: any
): Promise<VotingOperationsPimeetingsFilterListResponse> => {
  data = paginatedPiMeetingSearchListSchemaResponseTransformer(data)
  return data
}

const proxyIntermediaryVotingRecommendationSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  return data
}

const providerVotingRecommendationSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.meeting_date = new Date(data.meeting_date)
  if (data.delete_time) {
    data.delete_time = new Date(data.delete_time)
  }
  return data
}

const proposalSetRecommendationCoverageProposalSchemaResponseTransformer = (data: any) => {
  data.proposal = proxyIntermediaryProposalSchemaResponseTransformer(data.proposal)
  if (data.proxy_intermediary_voting_recommendation) {
    data.proxy_intermediary_voting_recommendation = proxyIntermediaryVotingRecommendationSchemaResponseTransformer(
      data.proxy_intermediary_voting_recommendation
    )
  }
  if (data.provider_voting_recommendation) {
    data.provider_voting_recommendation = providerVotingRecommendationSchemaResponseTransformer(
      data.provider_voting_recommendation
    )
  }
  return data
}

const proposalSetRecommendationCoverageDetailSchemaResponseTransformer = (data: any) => {
  data.proposals = data.proposals.map((item: any) =>
    proposalSetRecommendationCoverageProposalSchemaResponseTransformer(item)
  )
  data.unmatched_provider_voting_recommendations = data.unmatched_provider_voting_recommendations.map((item: any) =>
    providerVotingRecommendationSchemaResponseTransformer(item)
  )
  return data
}

export const votingPolicyProposalSetRecommendationCoverageDetailRetrieveResponseTransformer = async (
  data: any
): Promise<VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponse> => {
  data = proposalSetRecommendationCoverageDetailSchemaResponseTransformer(data)
  return data
}

const proposalSetRecommendationCoverageSchemaResponseTransformer = (data: any) => {
  data.earliest_vote_deadline = new Date(data.earliest_vote_deadline)
  data.latest_vote_deadline = new Date(data.latest_vote_deadline)
  data.earliest_adjusted_vote_deadline = new Date(data.earliest_adjusted_vote_deadline)
  data.vote_deadlines = data.vote_deadlines.map((item: any) => new Date(item))
  data.ballot_count = BigInt(data.ballot_count.toString())
  data.meeting_time = new Date(data.meeting_time)
  data.proposal_count = BigInt(data.proposal_count.toString())
  data.matched_proposal_count = BigInt(data.matched_proposal_count.toString())
  data.manually_matched_proposal_count = BigInt(data.manually_matched_proposal_count.toString())
  data.pvr_matched_proposal_count = BigInt(data.pvr_matched_proposal_count.toString())
  data.unmatched_proposal_count = BigInt(data.unmatched_proposal_count.toString())
  return data
}

const paginatedProposalSetRecommendationCoverageListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proposalSetRecommendationCoverageSchemaResponseTransformer(item))
  return data
}

export const votingPolicyProposalSetRecommendationCoverageSearchCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProposalSetRecommendationCoverageSearchCreateResponse> => {
  data = paginatedProposalSetRecommendationCoverageListSchemaResponseTransformer(data)
  return data
}

export const votingPolicyProviderVotingRecommendationsCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProviderVotingRecommendationsCreateResponse> => {
  data = providerVotingRecommendationSchemaResponseTransformer(data)
  return data
}

const votingRecommendationSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const votingPolicyProviderVotingRecommendationsMatchCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProviderVotingRecommendationsMatchCreateResponse> => {
  data = votingRecommendationSchemaResponseTransformer(data)
  return data
}

const providerVotingRecommendationListResponseSchemaResponseTransformer = (data: any) => {
  data.provider_voting_recommendations = data.provider_voting_recommendations.map((item: any) =>
    providerVotingRecommendationSchemaResponseTransformer(item)
  )
  return data
}

export const votingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponseTransformer = async (
  data: any
): Promise<VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponse> => {
  data = providerVotingRecommendationListResponseSchemaResponseTransformer(data)
  return data
}

const paginatedProviderVotingRecommendationListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => providerVotingRecommendationSchemaResponseTransformer(item))
  return data
}

export const votingPolicyProviderVotingRecommendationsSearchCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProviderVotingRecommendationsSearchCreateResponse> => {
  data = paginatedProviderVotingRecommendationListSchemaResponseTransformer(data)
  return data
}

const proxyIntermediaryVotingRecommendationConfidenceScoreSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const votingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponse> => {
  data = proxyIntermediaryVotingRecommendationConfidenceScoreSchemaResponseTransformer(data)
  return data
}

const proxyIntermediaryVotingRecommendationValidationStatusSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  return data
}

export const votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponse> => {
  data = proxyIntermediaryVotingRecommendationValidationStatusSchemaResponseTransformer(data)
  return data
}

export const votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponseTransformer =
  async (
    data: any
  ): Promise<VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponse> => {
    data = proxyIntermediaryVotingRecommendationValidationStatusSchemaResponseTransformer(data)
    return data
  }

export const votingPolicyProxyIntermediaryVotingRecommendationsCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponse> => {
  data = proxyIntermediaryVotingRecommendationSchemaResponseTransformer(data)
  return data
}

export const votingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponse> => {
  data = proxyIntermediaryVotingRecommendationSchemaResponseTransformer(data)
  return data
}

const paginatedProxyIntermediaryVotingRecommendationListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => proxyIntermediaryVotingRecommendationSchemaResponseTransformer(item))
  return data
}

export const votingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponse> => {
  data = paginatedProxyIntermediaryVotingRecommendationListSchemaResponseTransformer(data)
  return data
}

export const votingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponseTransformer = async (
  data: any
): Promise<VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponse> => {
  data = proxyIntermediaryVotingRecommendationSchemaResponseTransformer(data)
  return data
}

const votingPolicySchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const votingPolicyVotingPoliciesCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesCreateResponse> => {
  data = votingPolicySchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesRetrieveResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesRetrieveResponse> => {
  data = votingPolicySchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesPartialUpdateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesPartialUpdateResponse> => {
  data = votingPolicySchemaResponseTransformer(data)
  return data
}

const votingPolicyDocumentSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  data.issue_time = new Date(data.issue_time)
  return data
}

const paginatedVotingPolicyDocumentListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => votingPolicyDocumentSchemaResponseTransformer(item))
  return data
}

export const votingPolicyVotingPoliciesDocumentsListResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesDocumentsListResponse> => {
  data = paginatedVotingPolicyDocumentListSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesDocumentsCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesDocumentsCreateResponse> => {
  data = votingPolicyDocumentSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesDocumentsRetrieveResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesDocumentsRetrieveResponse> => {
  data = votingPolicyDocumentSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesDocumentsPartialUpdateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesDocumentsPartialUpdateResponse> => {
  data = votingPolicyDocumentSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesVotingRecommendationsCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesVotingRecommendationsCreateResponse> => {
  data = votingRecommendationSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesVotingRecommendationsRetrieveResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponse> => {
  data = votingRecommendationSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponse> => {
  data = votingRecommendationSchemaResponseTransformer(data)
  return data
}

export const votingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponse> => {
  data = votingRecommendationSchemaResponseTransformer(data)
  return data
}

const paginatedVotingRecommendationListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => votingRecommendationSchemaResponseTransformer(item))
  return data
}

export const votingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponse> => {
  data = paginatedVotingRecommendationListSchemaResponseTransformer(data)
  return data
}

const paginatedVotingPolicyListSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => votingPolicySchemaResponseTransformer(item))
  return data
}

export const votingPolicyVotingPoliciesSearchCreateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingPoliciesSearchCreateResponse> => {
  data = paginatedVotingPolicyListSchemaResponseTransformer(data)
  return data
}

const votingRecommendationConfidenceScoreSchemaResponseTransformer = (data: any) => {
  data.create_time = new Date(data.create_time)
  data.update_time = new Date(data.update_time)
  return data
}

export const votingPolicyVotingRecommendationConfidenceScoresUpdateResponseTransformer = async (
  data: any
): Promise<VotingPolicyVotingRecommendationConfidenceScoresUpdateResponse> => {
  data = votingRecommendationConfidenceScoreSchemaResponseTransformer(data)
  return data
}
